import "normalize.css/normalize.css";
import getOr from 'lodash/fp/getOr';

import { setUpFooter } from "../../components/footer";
import { setUpHeader } from "../../components/header";
import { setUpMenu } from "../../components/menu";
import Env from "../../environments";
import { ROOT_GLOBAL } from "../../global/root";
import { LocalStorage } from "../../models/LocalStorage";
import { getCurrentUser } from "../../utils/firebase";
import { embedAllTrack } from "../../utils/script";

import "./style.scss";
import { GLOBAL_CONSTANTS } from "../../global/constants";
import { getParamUrl, validate } from "../../utils/utils";
import { upgrade, refreshToken } from "../../utils/api";
import { initTrackYourPlan } from "../../utils/track";
import { setUpBookDemo } from "../../components/bookNow";

const $ = window.$;

embedAllTrack();

initEvent();

function initEvent() {
  setUpHeader("Plans & upgrade");
  LocalStorage.requireLogin() && $('body').removeClass('invisible');
  initTrackYourPlan();
  setUpMenu();
  setUpFooter();
  setUpTier();
  equalHeight();
  $(window).resize(function () {
    equalHeight();
  });
  $('.pricing-box .get-started').on('click', function () {
    $('#trial form.trial-form button.survey').attr('data-id', $(this).attr('data-id'));
    $('#trial').modal("show");
  });
  $('.pricing-box .paynow a').on('click', function () {
    // $('#upgrade form.upgrade-form').removeClass('pay-as-you-go').removeClass('universe').removeClass('launch')
    // $('#upgrade form.upgrade-form').addClass($(this).attr('data-id'));
    // $('#upgrade form.upgrade-form').attr('data-id', $(this).attr('data-id'));
    // $('#upgrade').modal("show");
    // upgradePlan($(this).attr('data-id'))

    $('#booknow-modal').modal("show");
  })

  $('.pricing-box .button-box .upgrade').on('click', function () {
    upgradePlan($(this).attr('data-id'))
  });
  setUpTrialPopup();

  setUpBookDemo();
  // setupStripe();
}

function upgradePlan(pkg) {
  upgrade({
    pkg: GLOBAL_CONSTANTS.PLANS[pkg].id,
    trial: false
  }, function () {
    setUpTier();
    $('#trial .trial-form').addClass('done upgrade');
    $('#trial').modal("show");
  })
}

function equalHeight() {
  $('.section-pricing .top-box').css('height', 'unset');
  $('.section-pricing .top-box').height($('.section-pricing .pay-as-you-go .top-box').height());
}

function setUpTrialPopup() {
  $('#trial .trial-form button.survey').on('click', function () {
    const link = `${Env.DUTY_CAST_TRIAL_SURVEY_LINK}${getCurrentUser().email}`;
    const tier = GLOBAL_CONSTANTS.PLANS[$(this).attr('data-id')];
    window.open(link, '_blank');
    setTimeout(() => {
      upgrade({
        pkg: tier.id,
        trial: true
      }, function () {
        setUpTier();
        $('#trial .trial-form').removeClass('upgrade');
        $('#trial .trial-form').addClass('done');
        $('#trial').modal("show");
      })
    }, 120000)
  });
  $('#trial .trial-form button.back-home').on('click', function () {
    const cb = getParamUrl('cb');
    window.location.href = cb || ROOT_GLOBAL.USER_TRADE_ADVISORY;
  })
}

// eslint-disable-next-line no-unused-vars
function setupStripe() {
  // eslint-disable-next-line no-undef
  const stripe = Stripe(Env.DUTY_CAST_STRIPE_API_KEY);
  const elements = stripe.elements();

  const style = {
    base: {
      iconColor: '#666EE8',
      color: '#222222',
      lineHeight: '40px',
      fontWeight: 400,
      fontFamily: 'Montserrat',
      fontSize: '14px',

      '::placeholder': {
        color: '#747474',
      },
    },
  };

  const cardNumberElement = elements.create('cardNumber', {
    style: style,
    showIcon: true,
  });
  cardNumberElement.mount('#card-number');

  cardNumberElement.on('change', function (e) {
    handleMessage(e);
  })

  const cardExpiryElement = elements.create('cardExpiry', {
    style: style
  });
  cardExpiryElement.mount('#expiration-date');

  cardExpiryElement.on('change', function (e) {
    handleMessage(e);
  })

  const cardCvcElement = elements.create('cardCvc', {
    style: style
  });
  cardCvcElement.mount('#security-code');

  cardCvcElement.on('change', function (e) {
    handleMessage(e);
  })

  $('#upgrade form.upgrade-form .middle-box .card-box input[name=card-hoder]').on('keyup', function (e) {
    if (validate($(this))) {
      handleMessage();
    } else {
      handleMessage({
        error: {
          message: 'Please enter card holder name.'
        }
      });
    }
  })
}

function handleMessage(result) {
  const error = getOr('', 'error')(result);
  const message = getOr(GLOBAL_CONSTANTS.DEFAULT_ERROR, 'error.message')(result);
  if (error) {
    $('#upgrade form.upgrade-form').removeClass('error').addClass('error');
    $('#upgrade form.upgrade-form .bottom-box .message').text(message);
    return;
  }
  $('#upgrade form.upgrade-form').removeClass('error');
  $('#upgrade form.upgrade-form .bottom-box .message').text('');
}

function setUpTier(token) {
  const packed = LocalStorage.getPackageExpired();
  if (packed < Date.now()) {
    refreshToken(setUpTier);
  } else {
    const tier = LocalStorage.getTierFromToken(token);
    !LocalStorage.hasTrial() && $('.section-pricing .content-box').addClass('trial');
    $('.section-pricing .content-box').attr('data-type', tier.code);
  }
}